export const supportedLanguage = [
	{
		label: "en",
		value: "en",
	},
	{
		label: "it",
		value: "it",
	},
]
